/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Producttype1Inputs */

const en_producttype1 = /** @type {(inputs: Producttype1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Product Type`)
};

const de_producttype1 = /** @type {(inputs: Producttype1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Produkttyp`)
};

/**
* | output |
* | --- |
* | "Product Type" |
*
* @param {Producttype1Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const producttype1 = /** @type {((inputs?: Producttype1Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Producttype1Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_producttype1(inputs)
	return de_producttype1(inputs)
});
export { producttype1 as "productType" }